<template>
  <div class="invoice-apply-page">
    <navigation>申请发票</navigation>

    <div class="page-content" v-if="!loading">
      <!-- 顶部提示 -->
      <div class="tip-bar">
        <span class="tip-icon">!</span>
        <span class="tip-text">借款本金部分不属于可开票金额，开票抬头默认为您的真实姓名</span>
      </div>

      <!-- 借据列表 -->
      <div class="iou-list" v-if="iouList.length">
        <div
          class="iou-card"
          :class="{ selected: isSelected(item.id) }"
          v-for="item in iouList"
          :key="item.id"
          @click="toggleSelect(item.id)"
        >
          <div class="card-header">
            <span class="contract-no">{{ item.contractNo }}</span>
            <span class="ui-checkbox" :class="{ checked: isSelected(item.id) }"></span>
          </div>
          <div class="card-field">
            <span class="field-label">资方全称</span>
            <span class="field-value">{{ item.fundName }}</span>
          </div>
          <div class="card-field">
            <span class="field-label">本金 (元)</span>
            <span class="field-value">{{ item.principal }}</span>
          </div>
          <div class="card-divider"></div>
          <div class="card-field">
            <span class="field-label">实还利息 (元)</span>
            <span class="field-value">{{ item.paidInterest }}</span>
          </div>
          <div class="card-field">
            <span class="field-label">实还罚息 (元)</span>
            <span class="field-value">{{ item.paidPenalty }}</span>
          </div>
          <div class="card-field">
            <span class="field-label">实还服务费 (元)</span>
            <span class="field-value">{{ item.paidServiceFee }}</span>
          </div>
        </div>
      </div>

      <!-- 空状态 -->
      <div class="empty-state" v-else>
        <img class="empty-img" src="../quan/images/quan_empty.png" alt="暂无数据">
        <p class="empty-text">暂无数据</p>
        <p class="empty-hotline">详询客服热线：<a href="tel:4000100008">4000100008</a></p>
      </div>
    </div>

    <!-- 底部提交按钮 -->
    <div class="footer" v-if="iouList.length">
      <nd-button
        :disabled="!hasSelection"
        :loading="submitting"
        @click="submitApply"
      >提交申请</nd-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'InvoiceApply',

  data () {
    return {
      loading: true,
      submitting: false,
      iouList: [],
      selectedIds: []
    }
  },

  computed: {
    ...mapState('invoice', ['iouList as storeIouList', 'selectedIouIds']),

    hasSelection () {
      return this.selectedIds.length > 0
    }
  },

  created () {
    this.fetchIouList()
    this.$bus.$emit('ready')
  },

  methods: {
    ...mapActions('invoice', ['getInvoiceIouListX']),

    async fetchIouList () {
      try {
        const res = await this.getInvoiceIouListX()
        if (res.code === '000000' && res.data) {
          const list = res.data.loanList || []
          this.iouList = list.map(item => ({
            id: item.billNo,
            contractNo: item.billNo,
            fundName: item.fundName,
            principal: this.formatAmount(item.paidPrin),
            paidInterest: this.formatAmount(item.paidInt),
            paidPenalty: this.formatAmount(item.paidPen),
            paidServiceFee: this.formatAmount(item.paidServFee)
          }))
        }
      } catch (e) {
        console.error('获取借据列表失败', e)
      } finally {
        this.loading = false
        this.$bus.$emit('ready')
      }
    },

    formatAmount (val) {
      if (val == null) return '0.00'
      return Number(val).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },

    isSelected (id) {
      return this.selectedIds.includes(id)
    },

    toggleSelect (id) {
      const index = this.selectedIds.indexOf(id)
      if (index > -1) {
        this.selectedIds.splice(index, 1)
      } else {
        this.selectedIds.push(id)
      }
    },

    async submitApply () {
      if (!this.hasSelection || this.submitting) return

      // 缓存选中的billNo，人脸识别成功后使用
      this.$storage.set('invoice_apply_billNos', JSON.stringify(this.selectedIds))

      // 跳转人脸识别
      this.$router.push({
        path: '/authentication/face',
        query: {
          sceneType: 'INVOICE_APPLY',
          sceneNo: this.selectedIds.join(','),
          redirectUrl: '/invoice'
        }
      })
    }

    
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.invoice-apply-page {
  min-height: 100vh;
  background-color: #F7F7F7;
  padding-bottom: 140px;
}

.page-content {
  padding: 20px 24px;
}

/* 顶部提示条 */
.tip-bar {
  display: flex;
  align-items: flex-start;
  padding: 20px 24px;
  background: #FFF8F0;
  border-radius: 16px;
  margin-bottom: 20px;

  .tip-icon {
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    border-radius: 50%;
    background: #FF9F18;
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    margin-right: 12px;
    margin-top: 2px;
  }

  .tip-text {
    font-size: 24px;
    color: #996633;
    line-height: 36px;
    font-family: PingFangSC-Regular, PingFang SC;
  }
}

/* 借据卡片 */
.iou-card {
  background: #FFFFFF;
  border-radius: 16px;
  padding: 28px 24px;
  margin-bottom: 20px;
  border: 2px solid transparent;
  transition: all 0.2s ease;

  &.selected {
    background: #F0FFF4;
    border-color: #52C41A;
  }
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  .contract-no {
    font-size: 28px;
    color: #333333;
    font-weight: 500;
    font-family: PingFangSC-Medium, PingFang SC;
  }
}

/* 自定义复选框 */
.ui-checkbox {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 2px solid #CCCCCC;
  flex-shrink: 0;
  transition: all 0.2s ease;

  &.checked {
    background: #52C41A;
    border-color: #52C41A;

    &::after {
      content: '';
      display: block;
      width: 12px;
      height: 20px;
      border: 3px solid #FFFFFF;
      border-top: none;
      border-left: none;
      margin: 4px auto 0;
      transform: rotate(45deg);
    }
  }
}

.card-field {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;

  .field-label {
    font-size: 26px;
    color: #999999;
    font-family: PingFangSC-Regular, PingFang SC;
  }

  .field-value {
    font-size: 26px;
    color: #333333;
    font-family: PingFangSC-Regular, PingFang SC;
    text-align: right;
    word-break: break-all;
    max-width: 60%;
  }
}

.card-divider {
  height: 1px;
  background: #F0F0F0;
  margin: 12px 0;
}

.card-footer {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px dashed #E8E8E8;

  .invoice-amount {
    font-size: 24px;
    color: #999999;
    font-family: PingFangSC-Regular, PingFang SC;

    em {
      font-style: normal;
      color: #52C41A;
      font-weight: 500;
      font-size: 30px;
    }
  }
}

/* 空状态 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 0;
  background-color: #FFFFFF;
  border-radius: 20px;
}

.empty-img {
  width: 205px;
  height: 173px;
  margin-bottom: 32px;
}

.empty-text {
  font-size: 28px;
  color: #999999;
  font-family: PingFangSC-Regular, PingFang SC;
  margin-bottom: 16px;
}

.empty-hotline {
  font-size: 24px;
  color: #666666;
  font-family: PingFangSC-Regular, PingFang SC;

  a {
    color: #FF9F18;
    font-weight: 500;
    text-decoration: none;
  }
}

/* 底部按钮 */
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px 24px;
  padding-bottom: calc(16px + env(safe-area-inset-bottom));
  background: #FFFFFF;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.06);
  z-index: 10;
}
</style>
